










































import {Component, Prop, Vue} from 'vue-property-decorator';
import {TableEditType} from '@/enums/table';
import DeleteDialog from '@c/DeleteDialog.vue';
import EmulatorModulesEditDialog from './EmulatorModulesEditDialog.vue';
import {PModuleTableHeader} from '../../interfaces';
import {getAllModules} from '@/store/modules/entities/pmodules/pmoduleWithMeasurementsModule';
import {PModuleType} from '@/enums/configs';

@Component({
  components: {
    DeleteDialog,
    EmulatorModulesEditDialog,
  },
})
export default class Table extends Vue {
  @Prop()
  modules!: string;

  @Prop()
  filter!: PModuleType;

  pmodules: any[] = [];

  items: any[] = [];

  model: any = null;

  headers: PModuleTableHeader[] = [
    {
      text: 'Модуль',
      value: 'module_description',
      sortable: false,
    },
    {
      text: 'Наименование сценария',
      value: 'scenario_name',
      sortable: false,
    },
  ];

  get deleteDialog() {
    return this.$refs.deleteDialog as any;
  }

  get editDialog() {
    return this.$refs.editDialog as any;
  }

  get actualHeaders() {
    const actionsSlice = [
      {
        text: 'Действия',
        value: 'actions',
        sortable: false,
        width: 90,
      },
    ];
    return [...this.headers, ...actionsSlice];
  }

  async created() {
    this.pmodules = await getAllModules();
    if (!this.modules) return;
    this.items = JSON.parse(this.modules).map((x: any, index: number) => {
      return {
        index: index,
        module: x.module,
        module_description: this.pmodules.find(t => t.guid == x.module)?.name,
        scenario_name: x.scenario_name,
        scenario_params: x.scenario_params,
      };
    });
  }

  add() {
    const index = this.items.length ? this.items[this.items.length - 1].index + 1 : 0;
    this.openEditDialog(TableEditType.Add, {
      index: index,
      module: null,
      module_description: null,
      scenario_name: null,
      scenario_params: null,
    });
  }

  edit(item: any) {
    this.openEditDialog(TableEditType.Edit, item);
  }

  openEditDialog(actionType: TableEditType, item: any) {
    const {type, title} = this.getInitialParams(actionType);
    this.model = {...item};
    const options = {
      type,
      title,
      saveCallback: (data: any) => {
        data.module_description = this.pmodules.find(t => t.guid == data.module).name;
        if (actionType == TableEditType.Add) this.items.push({...data});
        else {
          const item = this.items.find(x => x.index == data.index);
          item.module = data.module;
          item.module_description = data.module_description;
          item.scenario_name = data.scenario_name;
          item.scenario_params = data.scenario_params;
        }
        this.editDialog.$refs.form.reset();
        this.editDialog.close();
        this.$emit(
          'update',
          JSON.stringify(
            this.items.map(x => {
              const result = {...x};
              delete result.index;
              delete result.module_description;
              return result;
            }),
          ),
        );
      },
    };
    this.editDialog.open(this.model, options);
  }

  deleteItem(item: any) {
    this.deleteDialog.open(item, {
      deleteCallback: (item: any) => {
        this.items = this.items.filter((x: any) => x.index != item.index);
        this.deleteDialog.close();
        this.$emit('update', JSON.stringify(this.items.map(x => x.guid)));
      },
    });
  }

  getInitialParams(actionType: TableEditType) {
    let params;
    switch (actionType) {
      case TableEditType.Add:
        params = {
          type: 'add',
          title: 'Создание',
        };
        break;
      case TableEditType.Edit:
        params = {
          type: 'edit',
          title: 'Редактирование',
        };
        break;
    }
    return params;
  }
}
